import { storage } from '@/firebase'
import api from './index'
import * as sha1 from 'js-sha1'

const downloadUrls = {}

function hash (file, callback) {
  const reader = new FileReader()
  reader.onload = (event) => {
    callback(sha1(event.target.result))
  }
  reader.readAsBinaryString(file)
}
function updateFileMetadata (ref, metadata, success, error) {
  return storage
    .ref(ref)
    .updateMetadata(metadata).then((m) => {
      if (success) success(m)
    }).catch((err) => {
      if (error) error(err)
    })
}


function uploadFile (file, to, success, progress, error) {
  const metadata = {
    cacheControl: 'public,max-age=3600',
    contentType: file.type,
    customMetadata: {
      owner: api.auth.user().uid
    }
  }
  const upload = storage
    .ref(to)
    .put(file, metadata)
  upload.on('state_changed', (snapshot) => {
    progress((snapshot.bytesTransferred / snapshot.totalBytes) * 100)
  }, (err) => {
    error(err)
  }, (res) => {
    downloadUrls[to] = upload.snapshot.downloadURL
    success(upload.snapshot.downloadURL)
  })
}

function getDownloadUrl (ref, success, error) {
  if (ref in downloadUrls) {
    if (success) success(downloadUrls[ref])
  } else {
    return storage
      .ref(ref)
      .getDownloadURL()
      .then((url) => {
        downloadUrls[ref] = url
        if (success) success(url)
      })
      .catch((err) => { if (error) error(err) })
  }
}

function downloadFile (ref, success, progress, error) {
  return getDownloadUrl(ref,
    (url) => {
      const xhr = new XMLHttpRequest()
      xhr.responseType = 'json'
      xhr.onload = (event) => {
        if (success) success(xhr.response)
      }
      xhr.open('GET', url)
      xhr.send()
    },
    (err) => {
      if (error) error(err)
    })
}

export default {
  updateMetadata: updateFileMetadata,
  download: downloadFile,
  url: getDownloadUrl,
  hash,
  upload: uploadFile
}



// WEBPACK FOOTER //
// ./src/api/files.js